import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form"; 
import FormButton from "../FormButton";
import Input from "../Input";
import Select from "../Select";
import { useState } from "react";
import { sendOperationsOfferHttp } from "../../http/renewalHttp/RenewalHttp"; 

export default function SendToOperationsModal({ offerData, handleClicked, persistedItems, setPersistedItems, ...props }) {
    const [selectedSku, setSelectedSku] = useState('');
    const [seats, setSeats] = useState('');
    const [tp, setTp] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [term, setTerm] = useState('1_year');
    const [offerType, setOfferType] = useState('without_offer'); // default to "With out offer"

    const skuList = ["Business Starter", "Business Standard", "Business Plus", "Enterprise Starter", "Enterprise Standard", "Enterprise Plus"];

    const handleAddSku = () => {    
        if (!selectedSku || !seats || !tp || !sellingPrice) {
            alert("Fill all fields: SKU, Seats, TP, Selling Price.");
            return;
        }

        const newItem = {
            renewal_id: offerData.renewal_id,
            sku_name: selectedSku,
            number_of_seats: seats,
            tp: tp,
            selling_price: sellingPrice,
            // FIX: Use the property names being passed from handleSendToOperations
            srd: offerData.renewal_date || 'N/A',
            grd: offerData.google_renewal_data || 'N/A',
            term: term,
            offer_type: offerType,
            operation_comments: ""
        };

        setPersistedItems(prev => [...prev, newItem]);
        setSelectedSku(''); setSeats(''); setTp(''); setSellingPrice('');
    };

    const handleRemoveSku = (indexToRemove) => {
        setPersistedItems(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (persistedItems.length === 0) { alert("Add at least one SKU."); return; }
        
       
        const finalTerm = persistedItems[0].term;

        const response = await sendOperationsOfferHttp({
            domain_name: offerData.domain_name,
            offer_items: persistedItems,
            term: finalTerm
        });

        if (response) {
            alert("BOM Email sent to Operations.");
            setPersistedItems([]);
            handleClicked(false);
        }
    };

    const termOptions = [
        { id: 'monthly', value: 'Monthly - Flex' }, // "monthly" stored in DB
        { id: '1_year', value: '12 months - 1 year' },
        { id: '2_years', value: '24 months - 2 years' },
        { id: '3_years', value: '36 months - 3 years' }
    ].map(t => <option key={t.id} value={t.id}>{t.value}</option>);


    return createPortal(
        <Div className="modal-backdrop">
            <dialog open style={{ zIndex: 1, margin: 'auto', width: '500px', padding: '20px' }}>
                <Div className="modal-content">
                    <h5 className="mb-3">Send to Operations: {offerData.domain_name}</h5>
                    <hr />
                    <Form onSubmit={handleSubmit}>
                        <Div className="form-group row mb-2">
                            <label className="col-md-4">SKU:</label>
                            <Div className="col-md-8">
                                <Select options={skuList.map(s => <option key={s} value={s}>{s}</option>)} value={selectedSku} onChange={(e) => setSelectedSku(e.target.value)} />
                            </Div>
                        </Div>
                        <Div className="form-group row mb-2">
                            <label className="col-md-4">Seats:</label>
                            <Div className="col-md-8">
                                <Input type="number" value={seats} onChange={(e) => setSeats(e.target.value)} />
                            </Div>
                        </Div>
                        <Div className="form-group row mb-2">
                            <label className="col-md-4">TP:</label>
                            <Div className="col-md-8">
                                <Input type="number" value={tp} onChange={(e) => setTp(e.target.value)} />
                            </Div>
                        </Div>
                        <Div className="form-group row mb-2">
                            <label className="col-md-4">Selling Price:</label>
                            <Div className="col-md-8">
                                <Input type="number" value={sellingPrice} onChange={(e) => setSellingPrice(e.target.value)} />
                            </Div>
                        </Div>
                        
                        <Div className="form-group row mb-3">
                            <label className="col-md-4">Term:</label>
                            <Div className="col-md-8">
                                <Select 
                                    options={termOptions} 
                                    value={term} 
                                    onChange={(e) => setTerm(e.target.value)} 
                                    disabled={persistedItems.length > 0} 
                                />
                            </Div>
                        </Div>

                        <Div className="form-group row mb-3">
                            <label className="col-md-4 ">Offer Type:</label>
                            <Div className="col-md-8 d-flex gap-3 align-items-center">
                                <div className="form-check" >
                                    <input 
                                        className="form-check-input" 
                                        type="checkbox" 
                                        id="withOffer" 
                                        checked={offerType === 'with_offer'}
                                        onChange={() => setOfferType('with_offer')} 
                                    />
                                    <label className="form-check-label ms-1" htmlFor="withOffer">With offer</label>
                                </div>
                                <div className="form-check">
                                    <input 
                                        className="form-check-input" 
                                        type="checkbox" 
                                        id="withoutOffer" 
                                        checked={offerType === 'without_offer'}
                                        onChange={() => setOfferType('without_offer')}
                                    />
                                    <label className="form-check-label ms-1" htmlFor="withoutOffer">Without offer</label>
                                </div>
                            </Div>
                        </Div>

                        <Div className="d-flex justify-content-end mb-3">
                            <FormButton type="button" className="btn btn-secondary btn-sm" onClick={handleAddSku}>Add SKU</FormButton>
                        </Div>

                        {persistedItems.length > 0 && (
                            <table className="table table-sm table-bordered">
                                <thead><tr><th>SKU</th><th>Seats</th><th>TP</th><th></th></tr></thead>
                                <tbody>{persistedItems.map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.sku_name}</td>
                                        <td>{item.number_of_seats}</td>
                                        <td>{item.tp}</td>
                                        <td>
                                            <button 
                                                type="button" 
                                                className="btn btn-danger btn-sm" 
                                                onClick={() => handleRemoveSku(i)}
                                            >x</button>
                                        </td>
                                    </tr>
                                ))}</tbody>
                            </table>
                        )}

                        <Div className="d-flex justify-content-end mt-3">
                            <FormButton type="submit" className="btn btn-primary mr-2">Send BOM</FormButton>
                            <FormButton type="button" className="btn btn-outline-secondary" onClick={() => handleClicked(false)}>Close</FormButton>
                        </Div>
                    </Form>
                </Div>
            </dialog>
        </Div>,
        document.getElementById("modal")
    );
}